import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import ProgressService from '../Services/progress/ProgressService';

export const GET_COURSE_PROGRESS_QUERY_KEY = 'getCourseProgress';
export const GET_CHAPTER_PROGRESS_QUERY_KEY = 'getChapterProgress';

export const useGetCourseProgress = (courseId) => {
  const navigate = useNavigate();
  
  return useQuery({
    queryKey: [GET_COURSE_PROGRESS_QUERY_KEY, courseId],
    queryFn: () => ProgressService.getCourseProgress(courseId),
    onError: (err) => {
      // Handle different error cases
      if (err.response && err.response.status === 403) {
        // Check for specific error code for subscription required
        if (err.response.data?.code === 'SUBSCRIPTION_REQUIRED') {
          navigate('/app/courses');
        } 
        // Handle educational level mismatch
        else {
          navigate('/app/home');
        }
      }
    },
    retry: (failureCount, error) => {
      // Don't retry on 403 errors
      if (error.response && error.response.status === 403) {
        return false;
      }
      return failureCount < 3; // Retry other errors up to 3 times
    },
    // Improved caching configuration to prevent unnecessary refetches
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 60 * 60 * 1000, // 1 hour
    refetchOnWindowFocus: false, // Prevent refetch when window regains focus
    refetchOnMount: false // Use cached data when component remounts
  });
};

export const useGetChapterProgress = (chapterId) => {
  const navigate = useNavigate();
  
  return useQuery({
    queryKey: [GET_CHAPTER_PROGRESS_QUERY_KEY, chapterId],
    queryFn: () => ProgressService.getChapterProgress(chapterId),
    onError: (err) => {
      // Handle different error cases
      if (err.response && err.response.status === 403) {
        // Check for specific error code for subscription required
        if (err.response.data?.code === 'SUBSCRIPTION_REQUIRED') {
          navigate('/app/courses');
        } 
        // Handle educational level mismatch
        else {
          navigate('/app/home');
        }
      }
    },
    retry: (failureCount, error) => {
      // Don't retry on 403 errors
      if (error.response && error.response.status === 403) {
        return false;
      }
      return failureCount < 3; // Retry other errors up to 3 times
    },
    // Improved caching configuration to prevent unnecessary refetches
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 60 * 60 * 1000, // 1 hour
    refetchOnWindowFocus: false, // Prevent refetch when window regains focus
    refetchOnMount: false // Use cached data when component remounts
  });
};